import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { path } from 'ramda';

import { DefinitionHeader } from 'components/common/fields/DefinitionHeader';
import DocumentPreview from 'components/cards/document/DocumentPreview';
import DocumentDownload from 'components/cards/document/DocumentDownload';
import { getDocumentPreviewType } from 'helpers/documentsHelpers';
import EventShortResult from './EventShortResult';

export default class EventResult extends Component {
    static propTypes = {
        getEvent: PropTypes.object.isRequired,
    };

    isResultAdded = () => {
        const { getEvent: { data }} = this.props;

        return !!path(['documents', 0, 'id'], data);
    }

    getDocProps = () => {
        const { getEvent: { data } } = this.props;
        const document = path(['documents', 0], data);

        return {
            document,
            event: data,
            documentPreviewType: getDocumentPreviewType(document)
        };
    }

    render() {
        const docProps = this.getDocProps();
        const { getEvent: { data } } = this.props;

        const isOneExist = this.isResultAdded() || data.shortResult;

        return (
            <div>
                { isOneExist && <DefinitionHeader translate='events.result' iconType='building' /> }
                <EventShortResult data={data}/>
                { this.isResultAdded() &&
                    <div className="event-divider">
                        <div className="panel-view event-result">
                            { docProps.documentPreviewType ? (
                                <div>
                                    <DocumentPreview {...docProps} showFooter={true} />
                                </div>
                            ) : (
                                <div>
                                    <DocumentDownload {...docProps} />
                                    { docProps.document.name + '.' + docProps.document.fileType }
                                </div>
                            )}
                        </div>
                    </div>
                }
            </div>
        );
    }
}
